import { SectionCard } from '@atlas/ui-components'
import type { FileUsageRef } from '@/domain/asset-detail.types'

export interface UsedInPanelProps {
	usage: FileUsageRef[]
}

/**
 * MOCK stand-in (design §8.10): reverse work-order/campaign references have no
 * backend query today. No real navigation target since work-order/campaign detail
 * for these ids isn't in scope here. Presentational + storied.
 */
export function UsedInPanel({ usage }: UsedInPanelProps) {
	return (
		<SectionCard title="Used in" className="space-y-3 bg-ds-surface">
			{usage.length === 0 ? (
				<p className="text-sm text-ds-text-subtle">Not referenced by any work order or campaign yet.</p>
			) : (
				<ul className="space-y-1.5">
					{usage.map((u) => (
						<li key={u.id} className="text-sm text-ds-info">
							{u.label}
						</li>
					))}
				</ul>
			)}
		</SectionCard>
	)
}
